
import { Component, Input, OnInit, PLATFORM_ID, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { MatDrawerMode } from '@angular/material/sidenav';
import { RouterModule, Routes } from '@angular/router';

import { AppRoute } from '../../../../app/app.routes';
import { SimpleSideMenuComponent } from '../simple-side-menu/simple-side-menu.component';
import { PageOutletComponent } from '../../../../app/features/admin/page-outlet/page-outlet.component';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'lib-admin-layout',
    imports: [
    RouterModule,
    SimpleSideMenuComponent,
    PageOutletComponent
],
    template: `
    <lib-simple-side-menu
      [routes]="routes()"
      [title]="toolbarTitle()"
      [svgIconUrl]="svgIconUrl()"
      [imgHeight]="imgHeight()"
      [showToggle]="true"
      [mode]="mode"
      [opened]="opened"
      [isMobileLayout]="isMobileLayout"
    >
      <ng-content ngProjectAs="[toolbar]" />
      <app-page-outlet />
    </lib-simple-side-menu>
    <!-- @todo implement this -->
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [
        `
      :host {
        display: block;
      }
    `,
    ]
})
export class AdminLayoutComponent implements OnInit {
  private platformId = inject(PLATFORM_ID);

  readonly routes = input.required<AppRoute[]>();
  readonly toolbarTitle = input('SSIT');
  readonly svgIconUrl = input('../../assets/images/bold_cornell_seal_simple_white.svg');
  readonly imgHeight = input('45px');
  @Input() mode: MatDrawerMode = 'side'; // 'over' | 'push' | 'side'
  @Input() opened = true;
  @Input() isMobileLayout = false;

  get isBrowserOnly(): boolean {
    return isPlatformBrowser(this.platformId);
  }
  ngOnInit(): void {
    if (this.isBrowserOnly) {
      this.isMobileLayout = window.innerWidth <= 768; // @todo use media queries
      if (this.isMobileLayout) {
        this.mode = 'over';
        this.opened = false;
      }
    }
  }
}
